module.exports = __webpack_public_path__ + "img/dana.00a32bab.png";